/* Custom-design funnel page (sections/bc-funnel.liquid):
   idea + review carousels, mobile menu, sticky mobile CTA, header hide-on-scroll, FAQ accordion, CTA tagging. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 989px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  function wrap(i, n) { return ((i % n) + n) % n; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* Shared carousel input: arrow buttons, Left/Right keys, horizontal swipe (CSS gives the stage touch-action: pan-y). */
  function wire(root, swipeEl, step) {
    each(root.querySelectorAll('[data-dir]'), function (btn) {
      btn.addEventListener('click', function () { step(Number(btn.dataset.dir)); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      step(e.key === 'ArrowRight' ? 1 : -1);
    });
    if (!swipeEl) return;
    var x0 = null, y0 = 0, pid = null;
    // the stage follows the finger (damped, max 90px) so a swipe feels connected; CSS reads --drag
    function release() { x0 = null; swipeEl.classList.remove('is-dragging'); swipeEl.style.removeProperty('--drag'); }
    swipeEl.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX; y0 = e.clientY; pid = e.pointerId;
    });
    swipeEl.addEventListener('pointermove', function (e) {
      if (x0 === null || e.pointerId !== pid || reduce.matches) return;
      swipeEl.classList.add('is-dragging');
      swipeEl.style.setProperty('--drag', Math.max(-90, Math.min(90, (e.clientX - x0) * 0.6)) + 'px');
    });
    swipeEl.addEventListener('pointerup', function (e) {
      if (x0 === null || e.pointerId !== pid) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      release();
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    });
    swipeEl.addEventListener('pointercancel', release);
  }

  function initIdeas(root) {
    var slides = root.querySelectorAll('.bcf-ideas__slide');
    var items = root.querySelectorAll('.bcf-ideas__item');
    var n = slides.length;
    var active = 0;
    if (!n) return;
    function go(i) {
      active = wrap(i, n);
      each(slides, function (el, k) {
        el.classList.toggle('is-active', k === active);
        el.classList.toggle('is-prev', n > 1 && k === wrap(active - 1, n));
        el.classList.toggle('is-next', n > 2 && k === wrap(active + 1, n));
        el.setAttribute('aria-hidden', k === active ? 'false' : 'true');
      });
      each(items, function (el, k) { el.hidden = k !== active; });
    }
    each(slides, function (el, k) {
      el.addEventListener('click', function () { if (k !== active) go(k); });
    });
    wire(root, root.querySelector('.bcf-ideas__stage'), function (d) { go(active + d); });
    root.addEventListener('shopify:block:select', function (e) {
      var k = Array.prototype.indexOf.call(slides, e.target);
      if (k >= 0) go(k);
    });
    go(0);
  }

  function initReviews(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.bcf-rev'));
    var n = cards.length;
    if (!n) return;
    var half = Math.floor(n / 2);
    var active = Math.min(2, n - 1);
    var last = [];
    var live = root.querySelector('[data-bcf-live]');
    var timer = null, inView = false, hover = false, stopped = reduce.matches;
    var pauseBtn = root.querySelector('[data-bcf-pause]');
    // Pause/play control (WCAG 2.2.2): also reflects the automatic stop after any interaction
    function setPaused(p) {
      stopped = p; clearTimeout(timer);
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', p ? 'Start automatic rotation' : 'Pause automatic rotation');
      }
      if (!p) tick();
    }

    function go(i, user) {
      active = wrap(i, n);
      cards.forEach(function (el, k) {
        var pos = wrap(k - active + half, n) - half;
        // Only a card that wraps from one end of the row to the other skips the slide (it fades in at its new slot).
        // Moving two steps at once (clicking an outer card) still slides.
        if (last[k] !== undefined && Math.abs(pos - last[k]) > n / 2) el.classList.add('is-jump');
        el.style.setProperty('--pos', pos);
        el.classList.toggle('is-active', pos === 0);
        el.setAttribute('aria-current', pos === 0 ? 'true' : 'false');
        last[k] = pos;
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { cards.forEach(function (el) { el.classList.remove('is-jump'); }); });
      });
      if (user) {
        setPaused(true);
        var t = cards[active].querySelector('.bcf-rev__t');
        if (live) live.textContent = 'Review ' + (active + 1) + ' of ' + n + (t ? ': ' + t.textContent : '');
      }
    }

    // Gentle autoplay: only while on screen, pauses on hover/focus, stops for good after any interaction.
    function tick() {
      clearTimeout(timer);
      if (stopped || hover || !inView || document.hidden || n < 2) return;
      timer = setTimeout(function () { go(active + 1, false); tick(); }, 6500);
    }
    root.addEventListener('mouseenter', function () { hover = true; tick(); });
    root.addEventListener('mouseleave', function () { hover = false; tick(); });
    root.addEventListener('focusin', function () { hover = true; tick(); });
    root.addEventListener('focusout', function () { hover = false; tick(); });
    document.addEventListener('visibilitychange', tick);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; tick(); }, { threshold: 0.4 }).observe(root);
    }

    cards.forEach(function (el, k) {
      el.addEventListener('click', function () { if (k !== active) go(k, true); });
    });
    wire(root, root.querySelector('.bcf-reviews__viewport'), function (d) { go(active + d, true); });
    root.addEventListener('shopify:block:select', function (e) {
      var k = cards.indexOf(e.target);
      if (k >= 0) go(k, true);
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!stopped); });
    if (reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) setPaused(true); });
    go(active, false);
    if (reduce.matches) setPaused(true);
  }

  /* Opens the Crisp chat if it is on the page. Returns false when there is no chat to open. */
  function openChat() {
    var c = window.$crisp;
    // Before Crisp loads (or when it's blocked) $crisp is a plain queue array; only use it once the real API is there.
    if (!c || typeof c.is !== 'function') return false;
    c.push(['do', 'chat:show']);
    c.push(['do', 'chat:open']);
    return true;
  }

  function initHelp(bcf) {
    // Desktop: "Need Help?" opens the chat instead of a tel: link the computer can't dial. Phones keep tel:.
    each(bcf.querySelectorAll('[data-bcf-help]'), function (a) {
      a.addEventListener('click', function (e) {
        if (finePointer.matches && openChat()) e.preventDefault();
      });
    });
    each(bcf.querySelectorAll('[data-bcf-chat]'), function (b) {
      b.addEventListener('click', function () {
        if (!openChat()) window.location.href = 'tel:+18886257772';
      });
    });
  }

  function initMenu(bcf) {
    var dlg = bcf.querySelector('.bcf-menu');
    var btn = bcf.querySelector('[data-bcf-menu-open]');
    if (!dlg || !btn) return;
    if (typeof dlg.showModal !== 'function') { btn.style.display = 'none'; return; } // CSS display beats [hidden]
    var root = document.documentElement, byKey = false;
    function open() {
      dlg.classList.toggle('by-pointer', !byKey); // tap/click, not keyboard: no focus box on the autofocused X
      dlg.showModal();
      root.classList.add('bcf-lock');
      btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
    }
    function close() {
      if (!dlg.open || !dlg.classList.contains('is-open')) return;
      dlg.classList.remove('is-open');
      setTimeout(function () { if (dlg.open) dlg.close(); }, reduce.matches ? 0 : 380);
    }
    dlg.addEventListener('close', function () {
      dlg.classList.remove('is-open');
      root.classList.remove('bcf-lock');
      btn.setAttribute('aria-expanded', 'false');
      if (!byKey && document.activeElement === btn) btn.blur(); // else the header stays solid over the hero and never auto-hides
    });
    btn.addEventListener('click', function (e) { byKey = e.detail === 0; open(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-bcf-menu-close]')) close();
      // a[href]: the menu's section toggles (Engagement Rings, About) are <a> without href and open in place
      else if (e.target.closest('a[href]')) { dlg.classList.remove('is-open'); dlg.close(); }
      else if (e.target.closest('[data-bcf-chat]')) { dlg.close(); }
    });
    var onBp = function () { if (!mobile.matches && dlg.open) dlg.close(); };
    if (mobile.addEventListener) mobile.addEventListener('change', onBp);
  }

  /* Header slides away while scrolling down past the hero and comes back on any scroll up. */
  function initHeader(bcf) {
    var head = bcf.querySelector('.bcf-head-wrap');
    var hero = bcf.querySelector('.bcf-hero');
    if (!head) return;
    var lastY = window.scrollY, queued = false;
    function update() {
      queued = false;
      var y = window.scrollY;
      // past the hero: white text would sit on light sections, so the header goes solid
      bcf.classList.toggle('is-scrolled', y > (hero ? hero.offsetTop + hero.offsetHeight - head.offsetHeight : 300));
      var past = y > (hero ? hero.offsetTop + hero.offsetHeight * 0.6 : 400);
      if (Math.abs(y - lastY) < 6) return;
      var busy = (finePointer.matches && head.matches(':hover')) || head.contains(document.activeElement);
      var hide = past && y > lastY && !busy;
      bcf.classList.toggle('is-head-hidden', hide);
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }, { passive: true });    update();
  }

  /* Mobile booking bar: visible once the hero is gone, hidden while another booking CTA block or the footer is on screen. */
  function initSticky(bcf) {
    var bar = bcf.querySelector('[data-bcf-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var blockers = [
      bcf.querySelector('.bcf-hero'),
      bcf.querySelector('.bcf-consult'),
      bcf.querySelector('.bcf-close'),
      document.querySelector('.shopify-section-group-footer-group')
    ].filter(Boolean);
    var seen = [];
    function set() {
      var on = mobile.matches && seen.length === 0;
      // full-width bar; CSS lifts the site call bubble + Crisp above it while this class is on
      document.documentElement.classList.toggle('bcf-sticky-on', on);
      bar.classList.toggle('is-on', on);
      bar.inert = !on;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var k = seen.indexOf(e.target);
        if (e.isIntersecting && k < 0) seen.push(e.target);
        if (!e.isIntersecting && k >= 0) seen.splice(k, 1);
      });
      set();
    });
    blockers.forEach(function (el) { io.observe(el); });
    if (window.$crisp) window.$crisp.push(['on', 'session:loaded', function () { set(); }]);
    if (mobile.addEventListener) mobile.addEventListener('change', set);
  }

  /* One-open-at-a-time FAQ with a height animation (native <details> still works without JS). */
  function initFaq(bcf) {
    var items = Array.prototype.slice.call(bcf.querySelectorAll('.bcf-faq__item'));
    function animate(d, opening) {
      var body = d.querySelector('.bcf-faq__a');
      if (body._bcfAnim) body._bcfAnim.cancel();
      d.classList.toggle('is-closing', !opening);
      if (opening) d.open = true;
      if (reduce.matches || !body.animate) { d.open = opening; d.classList.remove('is-closing'); return; }
      var full = { height: body.offsetHeight + 'px', paddingBottom: getComputedStyle(body).paddingBottom, opacity: 1 };
      var none = { height: '0px', paddingBottom: '0px', opacity: 0 };
      var a = body.animate(opening ? [none, full] : [full, none], { duration: opening ? 320 : 240, easing: 'cubic-bezier(.2,.7,.2,1)' });
      body._bcfAnim = a;
      a.onfinish = function () { body._bcfAnim = null; d.classList.remove('is-closing'); if (!opening) d.open = false; };
    }
    items.forEach(function (d) {
      d._bcfOpen = d.open; // intended state; d.open lags behind while a close animation runs
      d.addEventListener('toggle', function () { // find-in-page can open a <details> on its own
        if (!d.querySelector('.bcf-faq__a')._bcfAnim) d._bcfOpen = d.open;
      });
      d.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d._bcfOpen;
        if (opening) items.forEach(function (o) { if (o !== d && o._bcfOpen) { o._bcfOpen = false; animate(o, false); } });
        d._bcfOpen = opening;
        animate(d, opening);
      });
    });
  }

  /* Tag every booking link with where it was clicked (?src=funnel&cta=hero) and tell GTM.
     No utm_* on internal links: that would restart the GA4 session. Landing UTMs are kept for the booking form instead. */
  function initCtas(bcf) {
    var target = bcf.getAttribute('data-bcf-cta');
    if (!target) return;
    try {
      var q = new URLSearchParams(window.location.search), utm = [];
      q.forEach(function (v, k) { if (/^utm_/.test(k)) utm.push(k + '=' + v); });
      if (utm.length) sessionStorage.setItem('bcf_utm', utm.join('&'));
    } catch (e) { /* storage blocked: tagging below still works */ }
    var counts = {};
    each(bcf.querySelectorAll('a[href]'), function (a) {
      if (a.getAttribute('href') !== target) return;
      var where = a.closest('.bcf-head-wrap') ? 'header'
        : a.closest('.bcf-menu') ? 'menu'
        : a.closest('.bcf-sticky') ? 'sticky'
        : a.classList.contains('bcf-ann') ? 'announcement'
        : a.classList.contains('bcf-banner') ? 'banner'
        : ((a.closest('section') || {}).className || '').split(' ')[0].replace(/^bcf-/, '') || 'page';
      counts[where] = (counts[where] || 0) + 1;
      var id = counts[where] > 1 ? where + '-' + counts[where] : where;
      var url = new URL(a.href, window.location.origin);
      url.searchParams.set('src', 'funnel');
      url.searchParams.set('cta', id);
      a.href = url.pathname + url.search + url.hash;
      a.addEventListener('click', function () {
        (window.dataLayer = window.dataLayer || []).push({ event: 'bcf_cta_click', bcf_cta: id });
      });
    });
  }


  /* Booking popup: every booking CTA opens a 3-step calendar (type -> day + time -> details).
     Posts the same fields as the /pages/consultation form to Shopify's contact form. */
  function initBook(bcf) {
    var dlg = bcf.querySelector('[data-bcf-book]');
    var target = bcf.getAttribute('data-bcf-cta');
    if (!dlg || !target || typeof dlg.showModal !== 'function') return;
    var targetPath;
    try { targetPath = new URL(target, location.origin).pathname; } catch (e) { return; }
    var OPEN = parseFloat(dlg.dataset.openHour) || 10, CLOSE = parseFloat(dlg.dataset.closeHour) || 18;
    var CLOSED = String(dlg.dataset.closedDays || '').split(',').map(function (d) { return parseInt(d, 10); }).filter(function (d) { return d >= 0; });
    var AHEAD = parseInt(dlg.dataset.daysAhead, 10) || 45;
    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) {}
    // Opening hours, closed days and "today" are the business's (data-tz); slots are shown in the visitor's own time.
    var BIZ = dlg.dataset.tz || '', fmtBiz = null;
    try { if (BIZ) fmtBiz = new Intl.DateTimeFormat('en-US', { timeZone: BIZ, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }); } catch (e) { BIZ = ''; }
    function bizParts(ts) {
      var p = {}; fmtBiz.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = +x.value; });
      return { y: p.year, m: p.month - 1, d: p.day, h: p.hour % 24, min: p.minute };
    }
    function bizOffset(ts) { var p = bizParts(ts); return Date.UTC(p.y, p.m, p.d, p.h, p.min) - Math.floor(ts / 60000) * 60000; }
    function bizTime(day, h) { // wall-clock hour h (9.5 = 9:30) on calendar date `day`, in the business zone -> Date
      var y = day.getFullYear(), m = day.getMonth(), d = day.getDate(), hh = Math.floor(h), mm = Math.round((h % 1) * 60);
      if (!fmtBiz) return new Date(y, m, d, hh, mm);
      var wall = Date.UTC(y, m, d, hh, mm);
      return new Date(wall - bizOffset(wall - bizOffset(wall)));
    }
    // visitor in a different zone from the business? (decides how the zone line reads)
    var away = !!fmtBiz && Math.abs(bizOffset(Date.now()) + new Date().getTimezoneOffset() * 60000) > 60000;
    function zoneName() {
      try { return new Intl.DateTimeFormat(undefined, { timeZoneName: 'long' }).formatToParts(new Date()).filter(function (p) { return p.type === 'timeZoneName'; })[0].value; }
      catch (e) { return tz.replace(/_/g, ' '); }
    }
    var EMAIL_FIX = { 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'icloud.co': 'icloud.com', 'iclod.com': 'icloud.com', 'outlok.com': 'outlook.com', 'outlook.co': 'outlook.com' };
    var form = dlg.querySelector('.bcf-book__form');
    // Shopify rejects a /contact post without an hCaptcha token (400 'Missing CAPTCHA token'). We run our own invisible widget with Shopify's
    // site key so a challenge, when hCaptcha wants one, opens inside the popup; data-nocaptcha on the form keeps Shopify's own widget (whose challenge lands behind the modal) off it
    var chal = dlg.querySelector('.bcf-book__chal'), hcLoad = null, hcId = null, hcApi = null, hcBox = null;
    function siteKey() {
      var b = document.getElementById('captcha-bootstrap'), m = b && b.textContent.match(/'([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'/);
      return m ? m[1] : 'f06e6c50-85a8-45c8-87d0-21a2b65856fe';
    }
    function widget() {
      if (!hcLoad) hcLoad = (window.hcaptcha && hcaptcha.render ? Promise.resolve() : new Promise(function (y, n) {
        window.__bcfHc = y;
        var sc = document.createElement('script'); sc.async = true; sc.onerror = n;
        sc.src = 'https://js.hcaptcha.com/1/api.js?render=explicit&recaptchacompat=off&onload=__bcfHc';
        document.head.appendChild(sc);
      })).then(null, function (e) { hcLoad = null; throw e; });
      return hcLoad.then(function () {
        // Shopify's own forms (the footer newsletter) load a second hCaptcha that replaces window.hcaptcha; it does not know our
        // widget, so every send failed with 'Invalid hCaptcha id' (Sentry 2026-10-29). Render again on whichever copy is current.
        if (hcApi === window.hcaptcha) return;
        if (hcBox) hcBox.remove();
        hcBox = document.createElement('div'); form.appendChild(hcBox);
        hcApi = window.hcaptcha;
        hcId = hcApi.render(hcBox, { sitekey: siteKey(), size: 'invisible', 'challenge-container': chal,
          'open-callback': function () { chal.classList.add('is-on'); }, 'close-callback': function () { chal.classList.remove('is-on'); } });
      });
    }
    function token(again) {
      return widget().then(function () { return hcApi.execute(hcId, { async: true }); }).then(function (r) {
        chal.classList.remove('is-on'); hcApi.reset(hcId);
        var t = form.elements['h-captcha-response'];
        if (!t) { t = document.createElement('input'); t.type = 'hidden'; t.name = 'h-captcha-response'; form.appendChild(t); }
        t.value = r.response;
      }, function (e) {
        chal.classList.remove('is-on'); try { if (hcId != null) hcApi.reset(hcId); } catch (x) {}
        if (!again && /Invalid hCaptcha id/i.test(String(e && e.message || e))) { hcApi = null; return token(true); } // swapped mid-send: render again once
        throw e;
      });
    }
    var state = { type: '', day: null, slot: null, cta: '', view: null };
    var today, last;
    function setToday() { // re-run on every open: the tab may have stayed open past midnight
      if (fmtBiz) { var p = bizParts(Date.now()); today = new Date(p.y, p.m, p.d); }
      else { today = new Date(); today.setHours(0, 0, 0, 0); }
      last = new Date(today); last.setDate(last.getDate() + AHEAD);
    }
    setToday();
    function push(o) { (window.dataLayer = window.dataLayer || []).push(o); }
    // The ONE lead per booking: same event, shape and event_id contract as assets/click-events.js (GTM Meta Lead Gen + bc-relay-shared dedup).
    function lead(d, via) {
      var fn = String(d.first || '').trim().toLowerCase(), ln = String(d.last || '').trim().toLowerCase();
      var em = String(d.email || '').trim().toLowerCase(), ph = String(d.phone || '').replace(/\D/g, '');
      var o = {
        event: 'contact_form_submit',
        event_id: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2),
        event_time: Math.floor(Date.now() / 1000), page_location: location.href, page_referrer: document.referrer || '',
        form_id: 'bcf-book', form_name: 'design-funnel-booking', form_action: '/contact',
        lead_source: 'design_funnel', bcf_cta: state.cta, bcf_type: state.type,
        email: em, phone: ph, name: (fn + ' ' + ln).trim(),
        'x-fb-ud-em': em, 'x-fb-ud-ph': ph, 'x-fb-ud-fn': fn, 'x-fb-ud-ln': ln
      };
      if (via) o.bcf_via = via;
      push(o);
    }
    // Booking capture: details typed but never sent, or a send that failed, still reach the CRM so a rep can call.
    // Same origin through the Shopify app proxy (/apps/bc/* → CRM, signed by Shopify). One id per attempt; the CRM keeps the furthest stage.
    var capId = null, capLast = '', capTimer = null;
    function capPost(b) {
      try { fetch('/apps/bc/booking-lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b), keepalive: true, credentials: 'omit' }).catch(function () {}); } catch (x) {}
    }
    function capVal(n) { var f = form.querySelector('[name="contact[' + n + ']"]'); return f ? f.value.trim() : ''; }
    function capture(stage, reason) {
      clearTimeout(capTimer); capTimer = null;
      var email = capVal('email'), phone = capVal('phone');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) email = '';
      if (phone.replace(/\D/g, '').length < 7) phone = '';
      if (!email && !phone) return;
      if (!capId) capId = window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : r & 3 | 8).toString(16); });
      var utm = ''; try { utm = sessionStorage.getItem('bcf_utm') || ''; } catch (x) {}
      var b = { cid: capId, stage: stage, email: email, phone: phone, first_name: capVal('first_name'), last_name: capVal('last_name'), budget: capVal('budget'),
        meeting_type: state.type, slot_iso: state.slot != null ? new Date(state.slot).toISOString() : '', slot_label: state.slot != null ? staffLabel() : '', cta: state.cta,
        lead_source: 'Design funnel popup' + (state.cta ? ' / ' + state.cta : '') + (utm ? ' / ' + utm : ''), about: capVal('body').slice(0, 2000), page: location.pathname,
        links: [capVal('reference_url'), capVal('reference_url_2')].filter(Boolean), reason: reason ? String(reason).slice(0, 120) : '' };
      Object.keys(b).forEach(function (k) { if (b[k] === '' || (Array.isArray(b[k]) && !b[k].length)) delete b[k]; });
      var key = JSON.stringify(b);
      if (stage === 'started' && key === capLast) return; // nothing new since the last save
      capLast = key; capPost(b);
    }
    function captureSoon() { clearTimeout(capTimer); capTimer = setTimeout(function () { capture('started'); }, 1500); }
    function captureSent(cid) { if (cid) capPost({ cid: cid, stage: 'sent' }); capId = null; capLast = ''; clearTimeout(capTimer); capTimer = null; }

    function go(n) {
      var cur = null;
      each(dlg.querySelectorAll('.bcf-book__step'), function (st) { var on = st.getAttribute('data-step') === String(n); st.hidden = !on; if (on) cur = st; });
      dlg.setAttribute('data-at', n);
      var main = dlg.querySelector('.bcf-book__main'); if (main) main.scrollTop = 0;
      push({ event: 'bcf_book_step', bcf_step: n, bcf_cta: state.cta });
      if (n === 2) renderCal();
      if (n === 3) {
        dlg.querySelector('.bcf-book__picked-t').textContent = state.type + ' · ' + label();
        var f = form.querySelector('input[name="contact[first_name]"]');
        if (f && !f.value && !matchMedia('(pointer: coarse)').matches) { f.focus(); return; }
      }
      // the control just used is now hidden: move focus to the new step's heading so keyboard + screen-reader users keep their place
      var h = cur && cur.querySelector('.bcf-book__t'); if (h) h.focus({ preventScroll: true });
    }
    // state.slot is a timestamp (ms). label() is for the visitor (their language + zone); staffLabel() goes into the lead email.
    function label() {
      if (!state.day || state.slot == null) return '';
      var s = new Date(state.slot);
      return s.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }) + ' at ' + s.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    }
    function staffLabel() {
      var s = new Date(state.slot), o = { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' };
      var biz = ''; try { if (BIZ) biz = s.toLocaleString('en-US', Object.assign({ timeZone: BIZ }, o)); } catch (e) {}
      return (biz ? biz + ' | visitor: ' : '') + s.toLocaleString('en-US', o) + (tz ? ' (' + tz + ')' : '') + ' | ' + s.toISOString();
    }
    function fmt(ts) { // slot button text; adds the weekday when the visitor's day differs from the business day picked
      var s = new Date(ts), o = { hour: 'numeric', minute: '2-digit' };
      if (state.day && s.getDate() !== state.day.getDate()) o.weekday = 'short';
      return s.toLocaleTimeString(undefined, o);
    }
    var NOTICE = 2 * 3600 * 1000; // at least 2 hours' notice
    function bookable(d) { return d >= today && d <= last && CLOSED.indexOf(d.getDay()) === -1 && bizTime(d, CLOSE - 0.5) - Date.now() > NOTICE; }
    function slotsFor(d) {
      var out = [], now = Date.now();
      for (var h = OPEN; h + 0.5 <= CLOSE; h += 0.5) {
        var t = bizTime(d, h).getTime();
        if (t - now > NOTICE) out.push(t);
      }
      return out;
    }
    function renderCal() {
      if (!state.view) {
        var first = new Date(today); while (!bookable(first) && first <= last) first.setDate(first.getDate() + 1);
        if (!state.day && bookable(first)) state.day = first; // land on the first open day with its times already showing
        state.view = new Date(first.getFullYear(), first.getMonth(), 1);
      }
      var v = state.view, grid = dlg.querySelector('.bcf-book__days');
      dlg.querySelector('.bcf-book__month').textContent = MONTHS[v.getMonth()] + ' ' + v.getFullYear();
      dlg.querySelector('[data-month="-1"]').disabled = v <= new Date(today.getFullYear(), today.getMonth(), 1);
      dlg.querySelector('[data-month="1"]').disabled = new Date(v.getFullYear(), v.getMonth() + 1, 1) > last;
      grid.innerHTML = '';
      for (var i = 0; i < v.getDay(); i++) grid.appendChild(document.createElement('span'));
      var days = new Date(v.getFullYear(), v.getMonth() + 1, 0).getDate();
      for (var dnum = 1; dnum <= days; dnum++) {
        var d = new Date(v.getFullYear(), v.getMonth(), dnum), b = document.createElement('button'), ok = bookable(d), on = !!state.day && +d === +state.day;
        b.type = 'button'; b.className = 'bcf-book__day' + (ok ? ' is-open' : '') + (on ? ' is-on' : ''); b.textContent = dnum;
        b.setAttribute('aria-label', d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }) + (ok ? '' : ', unavailable'));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (+d === +today) { b.classList.add('is-today'); b.setAttribute('aria-current', 'date'); }
        if (!ok) b.disabled = true;
        b.tabIndex = -1;
        b._d = d; grid.appendChild(b);
      }
      // roving tabindex: the day grid is one Tab stop, arrow keys move between open days
      var stop = grid.querySelector('.bcf-book__day.is-on:not(:disabled)') || grid.querySelector('.bcf-book__day.is-open:not(:disabled)');
      if (stop) stop.tabIndex = 0;
      renderSlots();
    }
    function renderSlots() {
      var wrap = dlg.querySelector('.bcf-book__slots'), t = dlg.querySelector('.bcf-book__slots-t');
      wrap.innerHTML = '';
      if (!state.day) { t.textContent = 'Choose a day'; }
      else {
        t.textContent = state.day.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
        var group = '';
        slotsFor(state.day).forEach(function (h) {
          var d = new Date(h), hr = d.getHours(), on = state.slot === h;
          // far-away visitors: studio hours can run past their midnight, so those go under the next day rather than a second 'Morning'
          var g = d.toDateString() !== state.day.toDateString() ? d.toLocaleDateString(undefined, { weekday: 'long' }) : hr < 12 ? 'Morning' : hr < 17 ? 'Afternoon' : 'Evening';
          if (g !== group) { group = g; var p = document.createElement('p'); p.className = 'bcf-book__slot-g'; p.textContent = g; wrap.appendChild(p); }
          var b = document.createElement('button'); b.type = 'button'; b.className = 'bcf-book__slot' + (on ? ' is-on' : '');
          b.textContent = fmt(h); b._h = h; b.setAttribute('aria-pressed', on ? 'true' : 'false');
          wrap.appendChild(b);
        });
      }
      var city = BIZ ? BIZ.split('/').pop().replace(/_/g, ' ') : '';
      dlg.querySelector('.bcf-book__tz').textContent = !tz ? '' : away
        ? 'Shown in your time (' + zoneName() + '). Our studio is in ' + city + '.'
        : 'Times in ' + zoneName();
      dlg.querySelector('[data-step="2"] [data-go="3"]').disabled = !(state.day && state.slot != null);
    }
    function open(cta) {
      state.cta = cta || '';
      widget().catch(function () {}); // load early: the first send shouldn't wait on the script
      setToday();
      // a time picked earlier may have passed (or lost its notice) while the popup was closed
      if (state.slot != null && state.slot - Date.now() < NOTICE) state.slot = null;
      if (state.day && state.day < today) state.day = null;
      if (state.view && state.view < new Date(today.getFullYear(), today.getMonth(), 1)) state.view = null;
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('bcf-book-open');
      go(state.type ? (state.day && state.slot != null ? 3 : 2) : 1);
      push({ event: 'bcf_book_open', bcf_cta: state.cta });
    }
    var byKey = false, downOnBackdrop = false;
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('bcf-book-open');
      if (dlg.getAttribute('data-at') !== '4' && capTimer) capture('started');
      // the browser hands focus back to the CTA; after a tap/click that keeps the header solid, un-hideable, and re-opens a mega panel
      var a = document.activeElement; if (!byKey && a && a !== document.body && bcf.contains(a)) a.blur();
      if (dlg.getAttribute('data-at') === '4') reset();
    });
    function reset() {
      state = { type: '', day: null, slot: null, cta: '', view: null }; form.reset(); form._tried = false;
      each(dlg.querySelectorAll('.bcf-book__type'), function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      var more = form.querySelector('.bcf-book__f--more'), mb = form.querySelector('.bcf-book__more'); if (more && mb) { more.hidden = true; mb.hidden = false; }
    }
    dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
    dlg.addEventListener('click', function (e) {
      var el;
      // chat lives outside the modal, so close first (initHelp opens Crisp, or falls back to the phone)
      if ((e.target === dlg && downOnBackdrop) || e.target.closest('[data-bcf-book-close]') || e.target.closest('[data-bcf-chat]')) { dlg.close(); return; }
      if ((el = e.target.closest('.bcf-book__type'))) {
        state.type = el.getAttribute('data-type');
        each(dlg.querySelectorAll('.bcf-book__type'), function (b) { b.classList.toggle('is-on', b === el); b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
        setTimeout(function () { if (dlg.open) go(2); }, 160);
      } else if ((el = e.target.closest('.bcf-book__day')) && !el.disabled) {
        state.day = el._d; state.slot = null;
        each(dlg.querySelectorAll('.bcf-book__day'), function (b) { var on = b === el; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        renderSlots();
        if (matchMedia('(max-width: 860px)').matches) { var sl = dlg.querySelector('.bcf-book__slots-wrap'); sl && sl.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' }); }
      } else if ((el = e.target.closest('.bcf-book__slot'))) {
        state.slot = el._h;
        each(dlg.querySelectorAll('.bcf-book__slot'), function (b) { var on = b === el; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        dlg.querySelector('[data-step="2"] [data-go="3"]').disabled = false;
        var picked = state.slot; // a tap on a time is the decision: move on, like the meeting-type cards do
        setTimeout(function () { if (dlg.open && state.slot === picked && dlg.getAttribute('data-at') === '2') go(3); }, reduce.matches ? 0 : 220);
      } else if ((el = e.target.closest('[data-month]'))) {
        if (!el.disabled) { state.view = new Date(state.view.getFullYear(), state.view.getMonth() + parseInt(el.getAttribute('data-month'), 10), 1); renderCal(); }
      } else if ((el = e.target.closest('.bcf-book__more'))) {
        var more = form.querySelector('.bcf-book__f--more'); more.hidden = false; el.hidden = true; more.querySelector('input').focus();
      } else if ((el = e.target.closest('.bcf-book__fix'))) {
        var em = form.querySelector('[name="contact[email]"]'); em.value = el.getAttribute('data-fix'); el.hidden = true; check(em); em.focus();
      } else if ((el = e.target.closest('[data-go]'))) {
        if (!el.disabled) go(parseInt(el.getAttribute('data-go'), 10));
      }
    });

    // field checks: on blur, live once a field is flagged, and all at once on submit
    function check(f) {
      var v = f.value.trim(), msg = '', isMail = f.type === 'email', isTel = f.type === 'tel';
      if (f.required && !v) msg = isMail ? 'Enter your email' : isTel ? 'Enter a phone number' : 'Required';
      else if (isMail && v && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Check your email address';
      else if (isTel && v && v.replace(/\D/g, '').length < 7) msg = 'Check your phone number';
      f.classList.toggle('is-bad', !!msg);
      if (msg) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid');
      var hint = f.parentNode.querySelector('.bcf-book__hint');
      if (hint) { hint.textContent = msg; hint.hidden = !msg; }
      var fixBtn = isMail && f.parentNode.querySelector('.bcf-book__fix');
      if (fixBtn) {
        var at = v.lastIndexOf('@'), fix = !msg && at > 0 && EMAIL_FIX[v.slice(at + 1).toLowerCase()];
        fixBtn.hidden = !fix;
        if (fix) { fixBtn.setAttribute('data-fix', v.slice(0, at) + '@' + fix); fixBtn.textContent = 'Did you mean ' + v.slice(0, at) + '@' + fix + '?'; }
      }
      return !msg;
    }
    var CHECKED = 'input[required], input[type="email"], input[type="tel"]';
    form.addEventListener('focusout', function (e) { var f = e.target; if (f.matches && f.matches(CHECKED) && (f.value || form._tried)) check(f); });
    form.addEventListener('input', function (e) { if (e.target.classList && e.target.classList.contains('is-bad')) check(e.target); captureSoon(); });
    form.addEventListener('focusout', function () { if (capTimer) capture('started'); });
    window.addEventListener('pagehide', function () { if (capId || capTimer) capture('started'); });

    function calLinks() {
      var s = new Date(state.slot);
      var e = new Date(s.getTime() + 30 * 60000);
      var z = function (d) { return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
      var title = 'Beyond Carat design consultation (' + state.type.toLowerCase() + ')';
      var details = 'Your complimentary 30-minute ring design consultation with Beyond Carat. We will confirm the time by email. To change it, call or text +1 (888) 625-7772.';
      dlg.querySelector('[data-cal="google"]').href = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) + '&dates=' + z(s) + '/' + z(e) + '&details=' + encodeURIComponent(details);
      dlg.querySelector('[data-cal="outlook"]').href = 'https://outlook.live.com/calendar/0/deeplink/compose?subject=' + encodeURIComponent(title) + '&startdt=' + encodeURIComponent(s.toISOString()) + '&enddt=' + encodeURIComponent(e.toISOString()) + '&body=' + encodeURIComponent(details);
      var ics = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Beyond Carat//Consultation//EN','BEGIN:VEVENT','UID:' + Date.now() + '@beyondcarat.com','DTSTAMP:' + z(new Date()),'DTSTART:' + z(s),'DTEND:' + z(e),'SUMMARY:' + title,'DESCRIPTION:' + details.replace(/,/g, '\\,'),'BEGIN:VALARM','TRIGGER:-PT30M','ACTION:DISPLAY','DESCRIPTION:' + title,'END:VALARM','END:VEVENT','END:VCALENDAR'].join('\r\n');
      var a = dlg.querySelector('[data-cal="ics"]'); if (a._url) URL.revokeObjectURL(a._url);
      a._url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' })); a.href = a._url;
    }
    function done(first, email) { // fill the success step
      dlg.querySelector('.bcf-book__summary').textContent = state.type + ' · ' + label();
      dlg.querySelector('.bcf-book__done .bcf-book__t').textContent = first ? 'Thank you, ' + first + '.' : 'Thank you.';
      var em = dlg.querySelector('.bcf-book__email'); if (em) em.textContent = email || 'your inbox';
      calLinks(); go(4);
    }

    // window capture runs before click-events.js' document listener: it would count a lead on every attempt (even invalid ones); we send one on success instead
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.stopPropagation();
      e.preventDefault();
      form._tried = true;
      var err = form.querySelector('.bcf-book__err'), bad = null;
      each(form.querySelectorAll(CHECKED), function (f) { if (!check(f) && !bad) bad = f; });
      if (bad) { err.hidden = false; err.textContent = 'Please check the highlighted fields.'; bad.focus(); return; }
      err.hidden = true;
      if (state.slot == null || state.slot - Date.now() < NOTICE) { state.slot = null; go(2); return; } // the picked time went stale while typing
      var utm = ''; try { utm = sessionStorage.getItem('bcf_utm') || ''; } catch (x) {}
      var first = form.querySelector('[name="contact[first_name]"]').value.trim(), email = form.querySelector('[name="contact[email]"]').value.trim();
      var last = form.querySelector('[name="contact[last_name]"]').value.trim(), phone = form.querySelector('[name="contact[phone]"]').value.trim();
      form.querySelector('[name="contact[consultation_type]"]').value = state.type;
      form.querySelector('[name="contact[preferred_date]"]').value = staffLabel();
      form.querySelector('[name="contact[lead_source]"]').value = 'Design funnel popup' + (state.cta ? ' / ' + state.cta : '') + (utm ? ' / ' + utm : '');
      var btn = form.querySelector('[type="submit"]'), bt = btn.querySelector('.bcf-book__submit-t'), was = bt ? bt.textContent : '';
      btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); if (bt) bt.textContent = 'Sending';
      capture('started');
      var cid = capId, leaving = false;
      function native() { // finish on Shopify's page; remember the booking so we can confirm it when Shopify sends the visitor back
        leaving = true;
        try { sessionStorage.setItem('bcf_book_pending', JSON.stringify({ type: state.type, day: +state.day, slot: state.slot, cta: state.cta, first: first, email: email, last: last, phone: phone, cid: cid })); } catch (x) {}
        HTMLFormElement.prototype.submit.call(form);
      }
      unbusy = function () { btn.disabled = false; btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); if (bt) bt.textContent = was; };
      var ac = window.AbortController ? new AbortController() : null, timer;
      token().then(function () {
        timer = ac && setTimeout(function () { ac.abort(); }, 20000);
        return fetch(form.action.split('#')[0], { method: 'POST', body: new FormData(form), credentials: 'same-origin', signal: ac ? ac.signal : undefined })
          .then(function (r) {
            if (/challenge/.test(r.url)) { native(); return false; } // spam check: finish on Shopify's page
            if (!r.ok) throw new Error('status ' + r.status);
            // Shopify redirects a stored contact submission to ?contact_posted=true
            if (!/contact_posted=true/.test(r.url)) { native(); return false; }
            return true;
          });
      })
        // the lead is stored from here on: a display error must not tell the visitor to send it again
        .then(function (ok) {
          if (!ok) return;
          push({ event: 'bcf_book_submit', bcf_cta: state.cta, bcf_type: state.type });
          lead({ first: first, last: last, email: email, phone: phone });
          captureSent(cid);
          try { if (dlg.open) done(first, email); else reset(); } catch (x) {}
        }, function (e) {
          err.hidden = false;
          var why = String(e && e.message || e);
          // Fleetwatch: a booking that did not send is invisible otherwise (Oct 17-18: a day of 400 'Missing CAPTCHA token').
          // The visitor closing the spam check is their choice, not a failure. No form fields go to Sentry.
          if (!/challenge-closed/.test(why)) {
            capture('failed', why); // the details go to the CRM so a rep can call
            if (window.bcReportError) try { window.bcReportError('consultation-submit-failed', { reason: why.slice(0, 80), cta: state.cta || '', meeting: state.type || '' }); } catch (x) {} // 'type' is reserved in a Sentry context
          }
          err.textContent = /challenge-closed/.test(why) ? 'Please finish the quick check so we can send your request.' : 'That didn’t send. Your details are still here: try again, or call +1 (888) 625-7772.';
        })
        .then(function () { clearTimeout(timer); if (!leaving) unbusy(); });
    }, true);
    var unbusy = null;
    // Back from Shopify's spam check restores this page from the back/forward cache with the button still on 'Sending'
    window.addEventListener('pageshow', function (e) { if (e.persisted && unbusy) unbusy(); });
    // the phone keyboard's 'next' key submits the form: move to the next field instead
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.type === 'submit') return;
      var fs = Array.prototype.filter.call(form.querySelectorAll('input:not([type=hidden]),select,textarea'), function (f) { return f.offsetParent; });
      var n = fs[fs.indexOf(e.target) + 1];
      if (n) { e.preventDefault(); n.focus(); }
    });

    // Back from Shopify's spam check: show the confirmation (and send the conversion) the popup would have
    if (/[?&]contact_posted=true/.test(location.search)) {
      var pend = null;
      try { pend = JSON.parse(sessionStorage.getItem('bcf_book_pending') || 'null'); sessionStorage.removeItem('bcf_book_pending'); } catch (x) {}
      if (pend && pend.slot) {
        state.type = pend.type || ''; state.day = new Date(pend.day); state.slot = pend.slot; state.cta = pend.cta || '';
        dlg.showModal(); document.documentElement.classList.add('bcf-book-open'); done(pend.first || '', pend.email || '');
        push({ event: 'bcf_book_submit', bcf_cta: state.cta, bcf_type: state.type, bcf_via: 'shopify_page' });
        lead(pend, 'shopify_page');
        captureSent(pend.cid);
      }
    }

    // Arrow keys move between days (Left/Right = 1 day, Up/Down = 1 week, Home/End = ends of the month)
    dlg.querySelector('.bcf-book__days').addEventListener('keydown', function (e) {
      var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
      if (!e.target.classList || !e.target.classList.contains('bcf-book__day')) return;
      var all = Array.prototype.slice.call(this.querySelectorAll('.bcf-book__day')), i = all.indexOf(e.target), n;
      if (e.key === 'Home' || e.key === 'End') {
        var open = all.filter(function (b) { return !b.disabled; });
        n = e.key === 'Home' ? open[0] : open[open.length - 1];
      } else if (step) {
        i += step; while (i >= 0 && i < all.length && all[i].disabled) i += step;
        n = all[i];
      } else return;
      if (!n) return;
      e.preventDefault(); e.target.tabIndex = -1; n.tabIndex = 0; n.focus();
    });

    // screen readers: booking links open a dialog
    each(bcf.querySelectorAll('a[href]'), function (a) {
      try { if (!dlg.contains(a) && new URL(a.href, location.origin).pathname === targetPath) a.setAttribute('aria-haspopup', 'dialog'); } catch (x) {}
    });

    // every booking link on the page opens the popup instead of navigating
    bcf.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || dlg.contains(a)) return;
      var u; try { u = new URL(a.href, location.origin); } catch (x) { return; }
      if (u.origin !== location.origin || u.pathname !== targetPath) return;
      e.preventDefault();
      byKey = e.detail === 0; // keyboard "click"
      open(u.searchParams.get('cta') || '');
    });
    // start fetching the aside ring image once a booking link is hovered/touched, so it is there when the popup opens
    var ring = dlg.querySelector('.bcf-book__ring');
    if (ring) bcf.addEventListener('pointerover', function warm(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && !dlg.contains(a) && a.pathname === targetPath) { ring.loading = 'eager'; bcf.removeEventListener('pointerover', warm); }
    });
  }

  function init(bcf) {
    if (bcf.dataset.bcfReady) return;
    bcf.dataset.bcfReady = '1';
    each(bcf.querySelectorAll('[data-bcf-ideas]'), initIdeas);
    each(bcf.querySelectorAll('[data-bcf-reviews]'), initReviews);
    initHelp(bcf);
    initMenu(bcf);
    initHeader(bcf);
    initSticky(bcf);
    initFaq(bcf);
    initCtas(bcf);
    initBook(bcf);
    initLocale(bcf);
  }

  /* Country/currency selects: submit on a mouse/touch pick or Enter/blur, never on an arrow key (WCAG 3.2.2) */
  function initLocale(bcf) {
    each(bcf.querySelectorAll('select[data-bcf-loc]'), function (sel) {
      var ptr = false, start = sel.value;
      sel.addEventListener('pointerdown', function () { ptr = true; });
      sel.addEventListener('change', function () { if (ptr) sel.form.submit(); });
      sel.addEventListener('keydown', function (e) { ptr = false; if (e.key === 'Enter') sel.form.submit(); });
      sel.addEventListener('blur', function () { ptr = false; if (sel.value !== start) sel.form.submit(); });
    });
  }

  each(document.querySelectorAll('.bcf'), init);
  document.addEventListener('shopify:section:load', function (e) {
    each(e.target.querySelectorAll('.bcf'), init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('.bcf')) document.documentElement.classList.remove('bcf-lock', 'bcf-book-open');
  });
})();



/* Motion: scroll reveals, loops that only run on screen, smooth FAQ (CSS: "Motion" in bc-funnel.css).
   Skipped in the theme editor so merchants always see the finished page. */
(function () {
  if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';
  var STEP = 60; // ms between items that come into view together
  var MAX_STEPS = 3;

  document.querySelectorAll('.bcf').forEach(function (root) {
    // Elements entering in the same callback are ordered top-to-bottom, left-to-right and staggered.
    // The huge top margin makes everything ABOVE the reveal line count as intersecting, so an element that a fast
    // scroll, the End key or a restored scroll position skipped past is still revealed (finished, no animation).
    var reveal = new IntersectionObserver(function (entries) {
      var hits = [];
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        reveal.unobserve(e.target);
        if (e.boundingClientRect.bottom <= 0) { e.target.classList.add('is-in', 'is-past'); return; }
        hits.push({ el: e.target, r: e.boundingClientRect });
      });
      hits.sort(function (a, b) {
        return Math.abs(a.r.top - b.r.top) > 24 ? a.r.top - b.r.top : a.r.left - b.r.left;
      });
      hits.forEach(function (h, i) {
        h.el.style.setProperty('--d', Math.min(i, MAX_STEPS) * STEP + 'ms');
        h.el.classList.add('is-in');
      });
    }, { rootMargin: '100000px 0px -8% 0px' });

    // Infinite accents (banner sheen, floating pills) pause off screen.
    var live = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); });
    });

    root.classList.add('bcf-anim');
    root.querySelectorAll('[data-bcf-reveal]').forEach(function (el) { reveal.observe(el); });
    root.querySelectorAll('[data-bcf-live]').forEach(function (el) { live.observe(el); });

  });
})();
